import { store } from '../../App'
import { FAIL_FETCH } from './Other'
import _ from 'lodash'
export const FETCH_CONTENT = 'FETCH_CONTENT'
export const FETCH_TOP_FOLDERS = 'FETCH_TOP_FOLDERS'
export const FETCH_USERS = 'FETCH_USERS'

export const LOAD_CONTENT = 'LOAD_CONTENT'
export const LOAD_TOP_FOLDERS = 'LOAD_TOP_FOLDERS'
export const LOAD_USERS = 'LOAD_USERS'
/**
  * buildContentQuery
  * @desc generic options for content queries
  * @param {queryInfo} query {accountId, startDate, endDate, location}
  * @param {queryOptions} options optional params for query requests
*/
export function buildContentQuery (query, options) {
  if (options.limit) {
    query.limit = options.limit
  }
  if (options.offset) {
    query.offset = options.offset
  }
  if (options.profile && options.profile[0].length > 0) {
    query.appProfileIds = options.profile
  } else {
    if (store.getState().filterSources.profiles[0] && store.getState().filterSources.profiles[0]._id === '0') {
      return { accountId: false }
    }
    query.appProfileIds = store.getState().filterSources.profiles.map(profile => profile._id)
  }
  if (options.group && options.group[0].length > 0) {
    query.groupIds = options.group
  } else {
    if (store.getState().filterSources.profiles[0] && store.getState().filterSources.profiles[0]._id === '0') {
      return {}
    }
    // query['groupIds'] = []
    // store.getState().filterSources.profiles.forEach((profile) => {
    //   query['groupIds'] = [...new Set([].concat(...[query['groupIds'], profile.groups]))]
    // })
    query.groupIds = ['AllGROUPS']
  }
  if (options.appType) {
    query.appType = options.appType
  } else {
    query.appType = 'ALL'
  }
  if (options.sort) {
    query.sortField = options.sort.split(' ')[0]
    query.sortDirection = (options.sort.split(' ')[1] + 'ending').toUpperCase()
  }
  return query
}

/**
  * fetchTopViewedContent
  * @desc generate a content fetch action for the Top Viewed Content
  * @param {string} ID account ID
  * @param {timsetamp} start startDate
  * @param {timsetamp} end endDate
  * @param {string} location the content location for the query
  * @param {queryOptions} options the optional parts of the content query
  * @return {action} action
*/
export function fetchTopViewedContent (ID, start, end, location, options) {
  // (accountId: String!, startDate: DateTime!, endDate: DateTime!, location: ContentLocation!, limit: Int, offset: Int)
  let query = { accountId: ID, startDate: start, endDate: end, location }
  query = buildContentQuery(query, options)
  if (query.accountId) {
    return { type: FETCH_CONTENT, query, destination: 'topViewed' }
  }
  return { type: FAIL_FETCH, query }
}

/**
  * fetchTopFeedContent
  * @desc generate a content fetch action for the Top Feed Content
  * @param {string} ID account ID
  * @param {timsetamp} start startDate
  * @param {timsetamp} end endDate
  * @param {string} location the content location for the query
  * @param {queryOptions} options the optional parts of the content query
  * @return {action} action
*/
export function fetchTopFeedContent (ID, start, end, location, options) {
  let query = { accountId: ID, startDate: start, endDate: end, location }
  query = buildContentQuery(query, options)
  if (query.accountId) {
    return { type: FETCH_CONTENT, query, destination: 'topFeed' }
  }
  return { type: FAIL_FETCH, query }
}

/**
  * fetchTopExploreContent
  * @desc generate a content fetch action for the Top Explore Content
  * @param {string} ID account ID
  * @param {timsetamp} start startDate
  * @param {timsetamp} end endDate
  * @param {string} location the content location for the query
  * @param {queryOptions} options the optional parts of the content query
  * @return {action} action
*/
export function fetchTopExploreContent (ID, start, end, location, options) {
  // (accountId: String!, startDate: DateTime!, endDate: DateTime!, location: ContentLocation!, limit: Int, offset: Int)
  let query = { accountId: ID, startDate: start, endDate: end, location }
  query = buildContentQuery(query, options)
  if (query.accountId) {
    return { type: FETCH_CONTENT, query, destination: 'topExplore' }
  }
  return { type: FAIL_FETCH, query }
}

/**
  * fetchMostEngagedContent
  * @desc generate a content fetch action for the Most Engaged Content
  * @param {string} ID account ID
  * @param {timsetamp} start startDate
  * @param {timsetamp} end endDate
  * @param {string} location the content location for the query
  * @param {queryOptions} options the optional parts of the content query
  * @return {action} action
*/
export function fetchMostEngaged (ID, start, end, location, options) {
  let query = { accountId: ID, startDate: start, endDate: end, location }
  query = buildContentQuery(query, options)
  if (query.accountId) {
    return { type: FETCH_CONTENT, query, destination: 'mostEngaged' }
  }
  return { type: FAIL_FETCH, query }
}

/**
  * fetchTopFolders
  * @desc generate a content fetch action for the Top Folders
  * @param {string} ID account ID
  * @param {timsetamp} start startDate
  * @param {timsetamp} end endDate
  * @param {queryOptions} options the optional parts of the content query
  * @return {action} action
*/
export function fetchTopFolders (ID, start, end, options) {
  const query = { accountId: ID, startDate: start, endDate: end }
  if (options.profile && options.profile[0].length > 0) {
    query.appProfileIds = options.profile
  } else {
    if (store.getState().filterSources.profiles[0]._id === '0') {
      return { type: FAIL_FETCH }
    }
    query.appProfileIds = store.getState().filterSources.profiles.map(profile => profile._id)
  }
  if (options.group && options.group[0].length > 0) {
    query.groupIds = options.group
  } else {
    if (store.getState().filterSources.profiles[0]._id === '0') {
      return { type: FAIL_FETCH }
    }
    // query['groupIds'] = []
    // store.getState().filterSources.profiles.forEach((profile) => {
    //   query['groupIds'] = [...new Set([].concat(...[query['groupIds'], profile.groups]))]
    // })
    query.groupIds = ['AllGROUPS']
  }
  if (options.appType) {
    query.appType = options.appType
  } else {
    query.appType = 'ALL'
  }
  if (options.limit) {
    query.limit = options.limit
  }
  if (options.offset) {
    query.offset = options.offset
  }
  return { type: FETCH_TOP_FOLDERS, query }
}

/**
  * fetchTopLiked
  * @desc generate a content fetch action for the Top Liked Content
  * @param {string} ID account ID
  * @param {timsetamp} start startDate
  * @param {timsetamp} end endDate
  * @param {queryOptions} options the optional parts of the content query
  * @return {action} action
*/
export function fetchTopLiked (ID, start, end, options) {
  let query = { accountId: ID, startDate: start, endDate: end }
  query = buildContentQuery(query, options)
  if (query.accountId) {
    return { type: FETCH_CONTENT, query, destination: 'topLiked' }
  }
  return { type: FAIL_FETCH, query }
}

/**
  * fetchTopCommented
  * @desc generate a content fetch action for the Top Commented
  * @param {string} ID account ID
  * @param {timsetamp} start startDate
  * @param {timsetamp} end endDate
  * @param {queryOptions} options the optional parts of the content query
  * @return {action} action
*/
export function fetchTopCommented (ID, start, end, options) {
  let query = { accountId: ID, startDate: start, endDate: end }
  query = buildContentQuery(query, options)
  if (query.accountId) {
    return { type: FETCH_CONTENT, query, destination: 'topCommented' }
  }
  return { type: FAIL_FETCH, query }
}

/**
  * fetchUsers
  * @desc generate a content fetch action for Users
  * @param {string} ID account ID
  * @param {timsetamp} start startDate
  * @param {timsetamp} end endDate
  * @param {queryOptions} options the optional parts of the content query
  * @return {action} action
*/
export function fetchUsers (ID, start, end, options = {}) {
  const query = _.merge({ accountId: ID, startDate: start, endDate: end }, buildUserQuery(options))
  if (query.type === FAIL_FETCH) {
    return { type: FAIL_FETCH }
  }
  return { type: FETCH_USERS, query }
}

/**
  * buildUserQuery
  * @desc build a user queries options
  * @param {queryOptions} options the optional parts of the user query
  * @return {action} action
*/
export function buildUserQuery (options) {
  const query = {}
  if (options.adminType) {
    query.userAdminType = options.adminType
  }
  if (options.onlyAdmins) {
    query.onlyAdmins = options.onlyAdmins
  }
  if (options.limit) {
    query.limit = options.limit
  }
  if (options.offset) {
    query.offset = options.offset
  }
  if (options.sort) {
    query.sortField = options.sort.split(' ')[0]
    query.sortDirection = (options.sort.split(' ')[1] + 'ending').toUpperCase()
  }
  if (options.profile && options.profile[0].length > 0) {
    query.appProfileIds = options.profile
  } else {
    if (store.getState().filterSources.profiles[0]._id === '0') {
      return { type: FAIL_FETCH }
    }
    query.appProfileIds = store.getState().filterSources.profiles.map(profile => profile._id)
  }
  if (options.group && options.group[0].length > 0) {
    query.groupIds = options.group
  } else {
    if (store.getState().filterSources.profiles[0]._id === '0') {
      return { type: FAIL_FETCH }
    }
    query.groupIds = ['AllGROUPS']
    // store.getState().filterSources.profiles.forEach((profile) => {
    //   query['groupIds'] = [...new Set([].concat(...[query['groupIds'], profile.groups]))]
    // })
  }
  if (options.appType) {
    query.appType = options.appType
  } else {
    query.appType = 'ALL'
  }
  return query
}

/**
  * loadContent
  * @desc Load Content result
  * @param {Object} data data to load
  * @param {string} destination destination entry
  * @return {action} loadContentAction
*/
export function loadContent (data, destination) {
  return { type: LOAD_CONTENT, data, destination }
}

/**
  * loadTopFolders
  * @desc Load Top Folders result
  * @param {Object} data data to load
  * @return {action} loadTopFoldersAction
*/
export function loadTopFolders (data) {
  return { type: LOAD_TOP_FOLDERS, data }
}

/**
  * loadUsers
  * @desc Load Users
  * @param {Object} data data to load
  * @return {action} loadUsersAction
*/
export function loadUsers (data) {
  return { type: LOAD_USERS, data }
}
